/*
 * Copyright (c) 2023 Potentially Ltd
 *
 * Please see distribution for license
 */

import { GoalCardDetail } from '../../../../../shared/models';

export class SetPlaylistGoalCards {
  static readonly type = '[Playlist goals editor] Set Playlist Goal Cards';

  constructor(public goalCards: GoalCardDetail[]) {}
}
